import React from "react";
import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import { FaQuestion } from "react-icons/fa";
import { styled } from "@mui/material/styles";

type InfoModalButtonProps = {
  message: string;
  isAbsolute?: boolean;
};

const GrayCircleButton = styled(IconButton)<{ isabsolute?: string }>(
  ({ theme, isabsolute }) => ({
    backgroundColor: "#e0e0e0",
    color: "#333",
    borderRadius: "50%",
    width: 23,
    height: 23,
    position: isabsolute === "true" ? "absolute" : "relative",
    top: isabsolute === "true" ? 3 : "auto",
    right: isabsolute === "true" ? 3 : "auto",
    zIndex: 10,
    "&:hover": {
      backgroundColor: "#d5d5d5",
    },
  })
);

const modalStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

const InfoModalButton: React.FC<InfoModalButtonProps> = ({
  message,
  isAbsolute = false,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <GrayCircleButton onClick={handleOpen} isabsolute={isAbsolute.toString()}>
        <FaQuestion size={22} />
      </GrayCircleButton>

      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" gutterBottom>
            Informação
          </Typography>
          <Typography variant="body2">{message}</Typography>
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
            <Button variant="contained" color="primary" onClick={handleClose}>
              Fechar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export { InfoModalButton };
